// @ts-nocheck
import React, { useMemo } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListSubheader from '@mui/material/ListSubheader';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';

const ProductOptionsSelect = ({
    labelId,
    label,
    value,
    onChange,
    multiple = false,
    lawProductOptions = [],
    nonLawProductOptions = [],
    className,
    fullWidth = false,
    error = false,
    variant = 'outlined',
    sx,
    menuProps,
    allOptionLabel,
}) => {
    const allOptions = useMemo(() => [...lawProductOptions, ...nonLawProductOptions], [lawProductOptions, nonLawProductOptions]);

    const renderSelectedValue = (selected) => selected
        .map((id) => allOptions.find((product) => product.value === id)?.name)
        .filter(Boolean)
        .join(', ');

    const renderMenuItem = (product) => (
        <MenuItem key={ product.value } value={ product.value }>
            { multiple ? (
                <>
                    <Checkbox checked={ Array.isArray(value) && value.includes(product.value) } />
                    <ListItemText primary={ product.name } />
                </>
            ) : (
                product.name
            ) }
        </MenuItem>
    );

    return (
        <FormControl className={ className } fullWidth={ fullWidth } error={ error } sx={ sx } variant={ variant }>
            <InputLabel id={ labelId }>{ label }</InputLabel>
            <Select
                labelId={ labelId }
                multiple={ multiple }
                value={ value }
                onChange={ onChange }
                label={ label }
                variant={ variant }
                input={ multiple && variant === 'outlined' ? <OutlinedInput label={ label } /> : undefined }
                renderValue={ multiple ? renderSelectedValue : undefined }
                MenuProps={ menuProps }
            >
                { !multiple && allOptionLabel && (
                    <MenuItem value="">
                        { allOptionLabel }
                    </MenuItem>
                ) }
                { lawProductOptions.length > 0 && <ListSubheader>Jura</ListSubheader> }
                { lawProductOptions.map(renderMenuItem) }
                { nonLawProductOptions.length > 0 && <ListSubheader>Økonomi</ListSubheader> }
                { nonLawProductOptions.map(renderMenuItem) }
            </Select>
        </FormControl>
    );
};

export default ProductOptionsSelect;
